import {
    actions as filterActions,
} from '../filterData';
import {
    parseFilterQueryParams,
    expandFilterSet,
    copyFilterQueryParams,
} from '../filterData/filterUtils';
import {
    selectors as searchSelectors,
} from '../search';
import { selectFilterInfo } from './selectors';

function setFilterParams(queryParams, searchParams, passedDirection) {
    return (dispatch, getState) => {
        const direction = typeof searchParams === 'string'
            ? passedDirection
            : searchParams?.direction;
        const {
            filterId,
            carrierModesMap,
            travelModes,
            carriersByMode,
            stations,
        } = selectFilterInfo(getState(), searchParams);
        const parsedQueryParams = parseFilterQueryParams(queryParams, direction);

        const expandedFilterSet = expandFilterSet(
            parsedQueryParams,
            carrierModesMap,
            travelModes,
            carriersByMode,
            stations,
        );

        dispatch(filterActions.setBulk(expandedFilterSet, filterId));
    };
}

function updateFilterParams(searchParams) {
    return (dispatch, getState) => {
        const queryParams = searchSelectors.selectQueryParams(getState());
        dispatch(setFilterParams(queryParams, searchParams));
    };
}

function syncFilterParams(sourceFilterParams, targetSearchParams) {
    return (dispatch) => {
        const { direction: targetDirection } = targetSearchParams;
        const targetFilterParams = copyFilterQueryParams(sourceFilterParams, targetDirection);
        dispatch(setFilterParams(targetFilterParams, targetSearchParams));
    };
}

export {
    setFilterParams,
    syncFilterParams,
    updateFilterParams,
};
